import { render, staticRenderFns } from "./TipsNotice.vue?vue&type=template&id=0a5c6472&scoped=true&"
import script from "./TipsNotice.vue?vue&type=script&lang=js&"
export * from "./TipsNotice.vue?vue&type=script&lang=js&"
import style0 from "./TipsNotice.vue?vue&type=style&index=0&id=0a5c6472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c6472",
  null
  
)

export default component.exports